import { assertUnreachable } from 'utilities/buildTables/types.js';

/* set lineHeight to 24px to match the height of the icons in secondary section and / or pill */
export const PILL_HEIGHT_STYLE = { lineHeight: '24px' };

export type FlexAxisType = 'left' | 'top' | 'right' | 'above' | 'below' | 'bottom' | 'centre' | undefined;

export const convertToFlexAxisY = (labelPos?: FlexAxisType) => {
  switch (labelPos) {
    case 'below':
    case 'bottom':
      return 'u-flexAlignItemsBaseline';
    case 'top':
    case 'above':
      return 'u-flexAlignItemsEnd';
    case 'right':
    case 'left':
    case 'centre':
    case undefined:
      return 'u-flexAlignItemsCenter';
    default:
      assertUnreachable(labelPos);
  }
};

export const convertToFlexAxisX = (labelPos?: FlexAxisType) => {
  switch (labelPos) {
    case 'right':
    case undefined:
      return 'u-flexJustifyStart';
    case 'left':
      return 'u-flexJustifyEnd';
    case 'top':
    case 'above':
    case 'below':
    case 'bottom':
    case 'centre':
      return 'u-flexJustifyCenter';
    default:
      assertUnreachable(labelPos);
  }
};

export const centerPill = (
  labelPos: 'left' | 'top' | 'right' | 'above' | 'below' | 'bottom' = 'below',
  width: number,
) => {
  if (labelPos !== 'left' && labelPos !== 'right') {
    return -(width / 2);
  }
};
